import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import VideoListA from './VideoListA';
import EfTitle from '@elem/ui/ef-title';
import ProductMedia from '@elem/compCommon/ProductConstructor/Media';
import { useRouter } from 'next/router';

export default function TabMedia() {
    const { locale = 'us' } = useRouter();
    const items = [
        {
            poster: 'https://i.ytimg.com/vi/Fpdu5Jta_EE/maxresdefault.jpg',
            link: 'https://www.youtube.com/embed/Fpdu5Jta_EE?si=GkiWBVmduMCCot17',
            title: 'Full Review of DELTA 3 Plus',
        },
    ];
    return (
        <div className={styles.theComp}>
            <EfSpec className="spec-x" />
            <EfTitle>{locale === 'br' ? 'Explore as avaliações do Ecoflow DELTA Série 3!' : 'Explore Reviews of Ecoflow DELTA 3 Series!'}</EfTitle>
            <ProductMedia mediaList={items} theme={'white'} />
            <EfSpec className="spec-x" />
        </div>
    );
}
